/* HandyHubThai theme – small, dependency-free behaviours. */
(function () {
  'use strict';

  var cfg = window.HHT || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var root = document.documentElement;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------
     Chat links (kept in sync with snippets/contact-url.liquid)
  ------------------------------------------------------------------ */
  function enc(str) { return encodeURIComponent(str); }
  function fill(template, service) {
    var label = service || (root.lang === 'th' ? 'บริการดูแลบ้าน' : 'your home services');
    return String(template || '').split('[service]').join(label);
  }
  function chatUrl(channel, service) {
    if (channel === 'whatsapp') {
      var digits = String(cfg.whatsapp || '').replace(/[^\d]/g, '');
      if (!digits) return '';
      return 'https://wa.me/' + digits + '?text=' + enc(fill(cfg.whatsappMessage, service));
    }
    if (channel === 'line') {
      var id = String(cfg.lineId || '').trim();
      if (id) {
        if (id.charAt(0) === '@') {
          return 'https://line.me/R/oaMessage/' + enc(id) + '/?' + enc(fill(cfg.lineMessage, service));
        }
        return 'https://line.me/ti/p/~' + enc(id);
      }
      return cfg.lineUrl || '';
    }
    return '';
  }

  /* ------------------------------------------------------------------
     Analytics: dataLayer, gtag and Shopify customer events
  ------------------------------------------------------------------ */
  function track(name, data) {
    var payload = Object.assign({ page_type: document.body.className.split(' ')[0] || '' }, data || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
  }
  window.HHT.track = track;

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track]');
    if (!el) return;
    var kind = el.getAttribute('data-track');
    var data = {
      channel: el.getAttribute('data-channel') || (kind === 'book' ? 'booking_sheet' : ''),
      service: el.getAttribute('data-service') || '',
      placement: el.getAttribute('data-placement') || ''
    };
    if (kind === 'contact') track('hht_contact_click', data);
    else if (kind === 'book') track('hht_book_click', data);
    else track('hht_' + kind, data);
  });

  /* ------------------------------------------------------------------
     Pointer-following fill on solid buttons
  ------------------------------------------------------------------ */
  document.addEventListener('pointerover', function (e) {
    var b = e.target.closest && e.target.closest('.btn--solid');
    if (!b) return;
    var r = b.getBoundingClientRect();
    b.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    b.style.setProperty('--my', (e.clientY - r.top) + 'px');
  });

  /* ------------------------------------------------------------------
     Booking sheet
  ------------------------------------------------------------------ */
  var sheet = $('#booking-sheet');
  var lastTrigger = null;

  function updateSheetLinks() {
    if (!sheet) return;
    var picked = $('input[name="booking-service"]:checked', sheet);
    var service = picked ? picked.value : '';
    $$('[data-channel-link]', sheet).forEach(function (a) {
      var ch = a.getAttribute('data-channel-link');
      var url = chatUrl(ch, service);
      if (url) a.href = url;
      a.setAttribute('data-service', service);
    });
  }

  function openSheet(service, trigger) {
    if (!sheet || typeof sheet.showModal !== 'function') return false;
    var hasChannels = $$('[data-channel-link]', sheet).length > 0;
    if (!hasChannels) return false;
    if (service) {
      var match = $$('input[name="booking-service"]', sheet).filter(function (i) {
        return i.value.toLowerCase() === service.toLowerCase();
      })[0];
      if (match) match.checked = true;
    }
    updateSheetLinks();
    lastTrigger = trigger || null;
    sheet.showModal();
    document.body.classList.add('sheet-open');
    var checked = $('input[name="booking-service"]:checked', sheet);
    if (checked) checked.focus({ preventScroll: true });
    return true;
  }

  function closeSheet() {
    if (!sheet || !sheet.open) return;
    sheet.close();
  }

  if (sheet) {
    sheet.addEventListener('change', updateSheetLinks);
    sheet.addEventListener('close', function () {
      document.body.classList.remove('sheet-open');
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    });
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) closeSheet(); // backdrop click
      var closer = e.target.closest('[data-close-sheet]');
      if (closer) {
        if (closer.tagName === 'A') {
          var local = document.getElementById('quote-form');
          if (local) { e.preventDefault(); closeSheet(); local.scrollIntoView(); focusQuote(); return; }
        }
        closeSheet();
      }
    });
  }

  function focusQuote() {
    var first = $('#quote-form input:not([type=hidden]), #quote-form select');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-booking]');
    if (!t) return;
    var service = t.getAttribute('data-service') || '';
    if (openSheet(service, t)) {
      e.preventDefault();
      return;
    }
    // No chat channels set up: go to the quote form instead.
    var local = document.getElementById('quote-form');
    if (local) {
      e.preventDefault();
      local.scrollIntoView();
      var sel = $('#quote-form select[name="contact[service]"]');
      if (sel && service) sel.value = service;
      focusQuote();
    }
  });

  /* ------------------------------------------------------------------
     Floating contact widget
  ------------------------------------------------------------------ */
  var fab = $('[data-fab]');
  if (fab) {
    var toggle = $('[data-fab-toggle]', fab);
    var menu = $('#fab-menu', fab);
    var setFab = function (open) {
      fab.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      if (open) {
        var first = $('a, .btn', menu);
        if (first && first.focus) first.focus({ preventScroll: true });
        track('hht_widget_open', { placement: 'floating_widget' });
      }
    };
    toggle.addEventListener('click', function () { setFab(menu.hidden); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { setFab(false); toggle.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!menu.hidden && !fab.contains(e.target)) setFab(false);
    });
  }

  /* ------------------------------------------------------------------
     Mobile booking bar: show after the first screen
  ------------------------------------------------------------------ */
  var bar = $('[data-mobile-bar]');
  if (bar && bar.querySelector('a')) {
    document.body.classList.add('has-mobile-bar');
    var threshold = function () { return Math.min(window.innerHeight * 0.6, 520); };
    var onScrollBar = function () {
      bar.classList.toggle('is-visible', window.scrollY > threshold() || document.body.classList.contains('template-page'));
    };
    window.addEventListener('scroll', onScrollBar, { passive: true });
    onScrollBar();
  }

  /* ------------------------------------------------------------------
     Header: border on scroll, mobile drawer
  ------------------------------------------------------------------ */
  var header = $('.site-header');
  if (header) {
    var onScrollHeader = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScrollHeader, { passive: true });
    onScrollHeader();
  }

  var drawer = $('[data-drawer]');
  if (drawer) {
    var openers = $$('[data-drawer-open]');
    var panel = $('.drawer__panel', drawer);
    var setDrawer = function (open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      openers.forEach(function (o) { o.setAttribute('aria-expanded', String(open)); });
      document.body.style.overflow = open ? 'hidden' : '';
      if ('inert' in drawer) drawer.inert = !open;
      if (open) { var f = $('a, button', panel); if (f) f.focus(); }
      else if (openers[0]) openers[0].focus({ preventScroll: true });
    };
    if ('inert' in drawer) drawer.inert = true;
    openers.forEach(function (o) { o.addEventListener('click', function () { setDrawer(true); }); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__scrim')) setDrawer(false);
      if (e.target.closest('a[href]')) setDrawer(false);
      if (e.target.closest('[data-open-booking]')) setDrawer(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setDrawer(false);
    });
  }

  /* ------------------------------------------------------------------
     Language selector (submits Shopify's localization form)
  ------------------------------------------------------------------ */
  $$('[data-lang-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* ------------------------------------------------------------------
     Scroll reveals and one-time "in view" states
  ------------------------------------------------------------------ */
  var revealTargets = $$('[data-reveal], [data-inview]');
  if ('IntersectionObserver' in window && revealTargets.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    revealTargets.forEach(function (el) { io.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Hero chat: play once */
  $$('[data-chat]').forEach(function (chat) {
    requestAnimationFrame(function () { chat.classList.add('is-playing'); });
  });

  /* ------------------------------------------------------------------
     Service panels (desktop accordion, mobile carousel)
  ------------------------------------------------------------------ */
  $$('[data-panels]').forEach(function (wrap) {
    var panels = $$('.panel', wrap);
    var activate = function (p) {
      panels.forEach(function (x) {
        var on = x === p;
        x.classList.toggle('is-active', on);
        var trig = $('.panel__trigger', x);
        if (trig) trig.setAttribute('aria-expanded', String(on));
      });
    };
    panels.forEach(function (p) {
      var trig = $('.panel__trigger', p);
      if (!trig) return;
      trig.addEventListener('click', function () { activate(p); });
      trig.addEventListener('focus', function () { activate(p); });
      p.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover) and (min-width: 1024px)').matches) activate(p);
      });
    });
  });

  /* ------------------------------------------------------------------
     Before / after sliders
  ------------------------------------------------------------------ */
  $$('[data-compare]').forEach(function (el) {
    var range = $('input[type=range]', el);
    if (!range) return;
    var set = function () { el.style.setProperty('--pos', range.value + '%'); };
    range.addEventListener('input', set);
    set();
    // Gentle hint once it scrolls into view (skipped for reduced motion)
    if (!reduceMotion.matches && root.classList.contains('motion-ok') && 'IntersectionObserver' in window) {
      var hinted = false;
      var obs = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting || hinted) return;
        hinted = true; obs.disconnect();
        var start = null, from = 50;
        var step = function (ts) {
          if (!start) start = ts;
          var t = Math.min((ts - start) / 1400, 1);
          var v = from + Math.sin(t * Math.PI * 2) * 10 * (1 - t);
          range.value = v; set();
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }, { threshold: 0.6 });
      obs.observe(el);
    }
  });

  /* ------------------------------------------------------------------
     Quote form: pre-select service from URL (?service=) and track submits
  ------------------------------------------------------------------ */
  $$('form[data-quote-form]').forEach(function (form) {
    var params = new URLSearchParams(window.location.search);
    var sel = $('select[name="contact[service]"]', form);
    if (sel && params.get('service')) sel.value = params.get('service');
    form.addEventListener('submit', function () {
      track('hht_quote_submit', { service: sel ? sel.value : '', placement: form.getAttribute('data-placement') || '' });
    });
  });
})();
